import { compareStreamId, isStreamId } from '@/utils/stream.id';
import type { TypeTrafficRequest } from '@/types/traffic/types.traffic.live';

export default function trafficRequestsMerge(current: TypeTrafficRequest[], incoming: unknown, cap: number): TypeTrafficRequest[] {
    const byId = new Map<string, TypeTrafficRequest>();

    for (const row of current) byId.set(row.id, row);

    if (Array.isArray(incoming)) {
        for (const row of incoming) {
            if (row && typeof row === 'object' && isStreamId((row as TypeTrafficRequest).id)) byId.set((row as TypeTrafficRequest).id, row as TypeTrafficRequest);
        }
    }

    return [...byId.values()].sort((a, b) => compareStreamId(b.id, a.id)).slice(0, Math.max(0, cap));
}
